<!-- access log -->
<section class="main">
    <div class="mb-3 d-flex align-items-center justify-content-between bntFilters titles">
        <h1>Operators Log</h1>
        <button class="btn btn1" (click)="exportData()">Export</button>
    </div>
  <section class="tableSection">
    <div class="filters">
      <form [formGroup]="filter_form">
        <div class="row">
          <div class="col-4">
            <label>Operator Name</label>
            <input
              formControlName="operator_name"
              type="text"
              class="form-control"
            />
          </div>
          <div class="col-4">
            <label>Operator Email</label>
            <input formControlName="email" type="text" class="form-control" />
          </div>
          <div class="col-4 ">
            <label>Unit Name</label>
            <input type="text" class="form-control" />
          </div>
          <div class="col-4 mt-2">
            <label>Client Name</label>
            <input type="text" class="form-control" />
          </div>
          <div class="col-12 col-md-4 mt-2">
            <label>From</label>
            <div class="d-flex align-items-center datePicker">
              <input
                formControlName="valid_from"
                class="form-control"
                placeholder="Valid Form"
                [matDatepicker]="pickerform"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="pickerform"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerform></mat-datepicker>
            </div>
          </div>
          <div class="col-12 col-md-4 mt-2">
            <label>To</label>
            <div class="d-flex align-items-center datePicker">
              <input
                formControlName="valid_to"
                class="form-control"
                placeholder="Valid To"
                [matDatepicker]="pickertow"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="pickertow"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickertow></mat-datepicker>
            </div>
          </div>
        </div>
      </form>
      <div class="mt-3 bntFilters">
        <button class="btn btn1" (click)="filterData()">Filter</button>
        <button class="btn btn2" (click)="resetForm()">Reset</button>
      </div>
    </div>

    <div class="table-responsive ">
      <table class="table table-striped">
        <thead>
          <tr>
            <th class="headTh">API</th>
            <th class="headTh">Device IP</th>
            <th class="headTh">Email</th>
            <th class="headTh">Method</th>
            <th class="headTh">Operator id</th>
            <th class="headTh">Operator name</th>
            <th class="headTh">Request status</th>
            <th class="headTh">Time stamp log</th>
            <th class="headTh">Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of opreators_logs">
            <td>{{ item.API }}</td>
            <td>{{ item.device_IP }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.method }}</td>
            <td>{{ item.operator_id }}</td>
            <td>{{ item.operator_name }}</td>
            <td>{{ item.request_status }}</td>
            <td>{{ item.time_stamp_log }}</td>
            <td>{{ item.type }}</td>
          </tr>
        </tbody>
        <p *ngIf="opreators_logs.length == 0">No Data Found</p>
      </table>
    </div>
  </section>
  <div>
    <mat-paginator
      (page)="handlePageEvent($event)"
      [pageIndex]="pageNumber"
      [length]="pagesLength"
      [pageSize]="pageLimt"
      [pageSizeOptions]="[10, 25, 100, 150, 200]"
      aria-label="Select page"
    >
    </mat-paginator>
  </div>
</section>
